import { Link, NavLink, useNavigate } from "react-router-dom";
import { Shield, Search as SearchIcon } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function Header() {
    const navigate = useNavigate();
    const { isAdmin, logout } = useAuth();

    const handleLogout = async () => {
        await logout();
        navigate("/");
    };

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-50 border-b border-zinc-200 bg-white/95 backdrop-blur-md"
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 md:px-12">
                <Link
                    to="/"
                    data-testid="site-logo-link"
                    className="flex items-center gap-3"
                >
                    <img
                        src="/roedt-logo.svg"
                        alt="Rødt"
                        className="h-9 w-auto"
                        width="51"
                        height="36"
                    />
                    <div className="leading-none">
                        <div className="font-heading text-base font-black tracking-tight text-zinc-950">
                            Program-arkivet
                        </div>
                        <div className="pp-overline mt-0.5">
                            Bergen · Vestland · Stortinget
                        </div>
                    </div>
                </Link>

                <nav className="flex items-center gap-1 md:gap-2">
                    <NavLink
                        to="/"
                        end
                        data-testid="nav-browse"
                        className={({ isActive }) =>
                            `px-3 py-2 text-sm font-medium transition-colors ${
                                isActive
                                    ? "text-zinc-950 underline decoration-2 underline-offset-8"
                                    : "text-zinc-600 hover:text-zinc-950"
                            }`
                        }
                    >
                        Bla
                    </NavLink>
                    <NavLink
                        to="/search"
                        data-testid="nav-search"
                        className={({ isActive }) =>
                            `flex items-center gap-1.5 px-3 py-2 text-sm font-medium transition-colors ${
                                isActive
                                    ? "text-zinc-950 underline decoration-2 underline-offset-8"
                                    : "text-zinc-600 hover:text-zinc-950"
                            }`
                        }
                    >
                        <SearchIcon className="h-4 w-4" /> Søk
                    </NavLink>
                    {isAdmin ? (
                        <button
                            data-testid="admin-logout-button"
                            onClick={handleLogout}
                            className="ml-2 inline-flex items-center gap-1.5 border border-zinc-300 bg-white px-3 py-2 text-sm font-medium text-zinc-700 hover:bg-zinc-50"
                        >
                            <Shield className="h-4 w-4" /> Logg ut
                        </button>
                    ) : (
                        <NavLink
                            to="/admin"
                            data-testid="nav-admin"
                            className="ml-2 inline-flex items-center gap-1.5 border border-zinc-300 bg-white px-3 py-2 text-sm font-medium text-zinc-700 hover:bg-zinc-50"
                        >
                            <Shield className="h-4 w-4" /> Admin
                        </NavLink>
                    )}
                </nav>
            </div>
        </header>
    );
}
